import { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useLocation } from "react-router-dom";
import { getHelpContent, HelpContent } from "../config/helpContent";
import { HelpPopover } from "./HelpPopover";
import { useDataEnvironment } from "../contexts/DataEnvironmentContext";

export const HelpButton = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [helpContent, setHelpContent] = useState<HelpContent>({
    title: 'Help',
    body: '',
    loading: true,
  });
  const location = useLocation();
  const { dataEnvironment } = useDataEnvironment();

  // Fetch help content when pathname changes
  useEffect(() => {
    const fetchHelp = async () => {
      setHelpContent({
        title: 'Help',
        body: '',
        loading: true,
      });

      const content = await getHelpContent(location.pathname);
      setHelpContent(content);
    };

    fetchHelp();
  }, [dataEnvironment, location.pathname]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleClick}
        aria-label="help"
        sx={{
          fontSize: 32,
          py: 0,
          pl: 1,
          pr: 0,
          '&:hover': {
            bgcolor: 'transparent',
            color: 'rgba(250, 204, 21, 0.96)',
          },
        }}
      >
        <HelpOutlineIcon />
      </IconButton>

      <HelpPopover
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorEl={anchorEl}
        helpContent={helpContent}
        currentPath={location.pathname}
      />
    </>
  );
};
